import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Button } from "../../base/button/button";
import { cn } from "../../../utils";
export function DialogShellFooter({ hint, secondary, primary, primaryRef, danger, leftSlot, dense = false, className }) {
    return(// Each action wraps its own label, and the row itself wraps, so a footer
    // whose actions are wider than the dialog spills onto a second line
    // instead of being clipped at the dialog edge.
    /*#__PURE__*/ _jsxs("footer", {
        className: cn("flex flex-wrap items-center justify-end gap-2 border-t border-line-subtle bg-surface-subtle", dense ? "px-5 py-3" : "px-5 py-3.5", className),
        children: [
            (danger || leftSlot || hint) && /*#__PURE__*/ _jsxs("div", {
                className: "mr-auto flex flex-wrap items-center gap-2",
                children: [
                    danger && /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "destructive",
                        wrap: true,
                        onClick: danger.onClick,
                        disabled: danger.disabled,
                        loading: danger.loading,
                        children: danger.label
                    }),
                    leftSlot,
                    hint && /*#__PURE__*/ _jsx("span", {
                        className: "text-xs text-muted-foreground",
                        children: hint
                    })
                ]
            }),
            secondary && /*#__PURE__*/ _jsx(Button, {
                type: "button",
                variant: "outline",
                wrap: true,
                onClick: secondary.onClick,
                disabled: secondary.disabled,
                loading: secondary.loading,
                children: secondary.label
            }),
            primary && /*#__PURE__*/ _jsxs(Button, {
                ref: primaryRef,
                type: primary.type ?? "button",
                variant: "primary",
                wrap: true,
                onClick: primary.onClick,
                disabled: primary.disabled,
                loading: primary.loading,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "inline-flex items-center",
                        children: primary.label
                    }),
                    primary.suffix
                ]
            })
        ]
    }));
}

//# sourceMappingURL=DialogShellFooter.js.map